/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, CircularProgress, debounce, Switch, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomInput from "../../components/inputs/customInput";
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import Popup from "../../components/popups/popup";
import { useTheme } from "@emotion/react";
import PostService from "../../services/postService";
import PostTypeDropdown from "../../components/dropdowns/postTypeDropdown";
import PageDropdown from "../../components/dropdowns/pageDropdown";
import CityDropdown from "../../components/dropdowns/cityDropdown";
import StreetDropdown from "../../components/dropdowns/streetDropdown";
import DriverDropdown from "../../components/dropdowns/driverDropdown";
import PostStatusDropdown from "../../components/dropdowns/postRelated/postStatusDropdown";
import TypeDropdown from "../../components/dropdowns/postRelated/typePostDropdown";
import ChangeStatusDropdown from "../../components/dropdowns/postRelated/changeStatusDropdown";
import BlockedNumberService from "../../services/blockedNumberService";
import { useNavigate, useParams } from "react-router-dom";
import CityPriceService from "../../services/cityPriceService";
import usePdfPost from "../../components/prints/pdfOnePost";
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';

const UpdatePost = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));
    const navigate = useNavigate();

    const { id } = useParams();

    const [post, setPost] = useState({});
    const [selectedPage, setSelectedPage] = useState(null);
    const [selectedPostType, setSelectedPostType] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedStreet, setSelectedStreet] = useState(null);
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [selectedPostStatus, setSelectedPostStatus] = useState(null);
    const [selectedType, setSelectedType] = useState(null);
    const [selectedChangeStatus, setSelectedChangeStatus] = useState(null);
    const [blockedNumber, setBlockedNumber] = useState(false);
    const [cityPrices, setCityPrices] = useState([]);

    const [showPopup, setShowPopup] = useState(false);
    const [popupMsg, setPopupMsg] = useState(false);
    const [popupType, setPopupType] = useState(false);

    const [showAllDrivers, setShowAllDrivers] = useState(false);
    const [pdf, setPdf] = useState(false);
    const [pdfPostId, setPdfPostId] = useState(null);
    const [print, setPrint] = useState(false);
    const { isLoading: isPDF, pdfPost } = usePdfPost();
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    const [formValues, setFormValues] = useState({
        receiverName: post.receiverName,
        receiverAddress: post.receiverAddress,
        receiverPhone: post.receiverPhone,
        receiverPhoneTwo: post.receiverPhoneTwo,
        invoiceNumber: post.invoiceNumber,
        totalPrice: post.totalPrice,
        transportationPrice: post.transportationPrice,
        driverPrice: post.driverPrice,
        note: post.note,
        pageId: post.pageId,
        postTypeId: post.postTypeId,
        driverId: post.driverId,
        streetId: post.streetId,
        postStatusId: post.postStatusId,
        type: post.type,
        changeStatus: post.changeStatus,
    });

    const [updateErrors, setUpdateErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isModalLoading, setIsModalLoading] = useState(true);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
        if (name === 'receiverPhone' || name === 'receiverPhoneTwo') {
            debouncedFetchData(value);
        }
    };

    const handleNumberChange = (e) => {
        const { name, value } = e.target;

        const numericValue = value === '-' ? '-' : value.replace(/,/g, '');

        if (!isNaN(numericValue) || numericValue === '-') {
            setFormValues((prevValues) => ({
                ...prevValues,
                [name]: numericValue,
            }));
        }
    };


    const debouncedFetchData = useMemo(() =>
        debounce((phone) => {
            fetchCheckPhone(phone);
        }, 1000), []
    );

    const validateForm = () => {
        const newUpdateErrors = {};

        if (!/^\d{11}$/.test(formValues.receiverPhone)) {
            newUpdateErrors.receiverPhone = t('receiverPhoneInvalid');
        }

        if (isNaN(formValues.totalPrice)) {
            newUpdateErrors.totalPrice = t('totalPriceNumber');
        }

        if (isNaN(formValues.driverPrice)) {
            newUpdateErrors.driverPrice = t('driverPriceNumber');
        }

        if (isNaN(formValues.transportationPrice)) {
            newUpdateErrors.transportationPrice = t('transportationPriceNumber');
        }

        if (!formValues.changeStatus && formValues.type === 'change') {
            newUpdateErrors.changeStatus = t('changeStatusRequired');
        }

        setUpdateErrors(newUpdateErrors);

        return Object.keys(newUpdateErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isLoading) return;

        if (validateForm()) {
            try {
                setIsLoading(true);
                console.log("request  ");


                let payload = {};
                if (formValues.type === 'change') {
                    const { cityId, ...otherData } = formValues;
                    payload = otherData;
                } else {
                    const { cityId, changeStatus, ...otherData } = formValues;
                    payload = otherData;
                }

                const data = await PostService.update(id, payload);
                if (data.status === 200) {
                    setPopupMsg(data.data.message);
                    setPopupType('success');
                    setShowPopup(true);
                    if (pdf) {
                        setPdfPostId(id);
                    } else if (print) {
                        handlePrint(id);
                    }
                    navigate('/posts');
                }

                setUpdateErrors({});
            } catch (error) {
                if (error.response?.status === 400) {
                    const responseErrors = error.response.data || {};
                    const formattedErrors = {};

                    Object.keys(responseErrors).forEach((field) => {
                        formattedErrors[field] = responseErrors[field];
                    });

                    setUpdateErrors(formattedErrors);
                } else {
                    setPopupMsg(error.response.data.error);
                    setPopupType('error');
                    console.error("An unexpected error occurred:", error);
                    setUpdateErrors({ general: error.response.data.error });
                }
            } finally {
                setIsLoading(false);
            }
        }
    };


    const handlePrint = async (id) => {
        try {
            console.log("printing post " + id);
            const response = await PostService.sendPostToPrint(id);
            console.log(response);
        } catch (error) {
            console.error('Error sending post:', error);
        } finally {
            setPrint(false);
        }
    };

    const fetchCheckPhone = async (phone) => {
        try {
            setBlockedNumber(false);
            const data = await BlockedNumberService.checkPhone(phone);
            if (data.isExist) setBlockedNumber(true);
        } catch (error) {
            console.error('Error fetching blocked number:', error);
        }
    };


    const fetchPost = async () => {
        try {
            const data = await PostService.fetchOne(id);
            setPost(data);
            setIsModalLoading(false);
        } catch (error) {
            console.error('Error fetching post:', error);
        }
    };

    const fetchCityPrices = async () => {
        try {
            const data = await CityPriceService.fetchByUser();
            setCityPrices(data);

        } catch (error) {
            console.error('Error fetching city prices:', error);
        }
    };

    const updateTransportationPrice = (cityId) => {
        if (!post.driverId) {
            if (selectedCity || selectedStreet) {
                const checkCity = cityPrices.find((obj) => obj.cityId === cityId);

                if (checkCity || !isInitialLoad) {
                    setFormValues((prevValues) => ({
                        ...prevValues,
                        transportationPrice: checkCity ? checkCity.transportationPrice : 0,
                    }));
                }

                if (isInitialLoad) {
                    setIsInitialLoad(false);
                    return;
                }
            }
            else if (cityPrices.length !== 0) {
                const checkPrice = cityPrices.find((obj) => obj.cityId === cityId);

                setFormValues((prevValues) => ({
                    ...prevValues,
                    transportationPrice: checkPrice ? checkPrice.transportationPrice : 0,
                }));

            }
        }
    };

    const updateDriverPrice = () => {
        if (!post.driverId) {
            if (selectedDriver && selectedStreet) {
                const checkPrice = selectedDriver.streetDrivers?.find((obj) => obj.streetId === selectedStreet.id);

                if (checkPrice) {
                    setFormValues((prevValues) => ({
                        ...prevValues,
                        driverPrice: checkPrice.transportationPrice,
                    }));
                } else {
                    setFormValues((prevValues) => ({
                        ...prevValues,
                        driverPrice: selectedDriver ? (selectedDriver.transportationPrice || 0) : 0,
                    }));
                }
            }
            else if (selectedDriver) {
                setFormValues((prevValues) => ({
                    ...prevValues,
                    driverPrice: selectedDriver ? (selectedDriver.transportationPrice || 0) : 0,
                }));
            }
        }
    };


    useEffect(() => {
        if (post) {
            setFormValues({
                receiverName: post.receiverName || '',
                receiverAddress: post.receiverAddress || '',
                receiverPhone: post.receiverPhone || '',
                receiverPhoneTwo: post.receiverPhoneTwo || '',
                invoiceNumber: post.invoiceNumber || '',
                totalPrice: post.totalPrice || 0,
                transportationPrice: post.transportationPrice || 0,
                driverPrice: post.driverPrice || 0,
                note: post.note || '',
                pageId: post.pageId || '',
                postTypeId: post.postTypeId || '',
                driverId: post.driverId || '',
                streetId: post.streetId || '',
                postStatusId: post.postStatusId || '',
                type: post.type || '',
                changeStatus: post.changeStatus || '',
            });
            setSelectedPage(post.page || null);
            setSelectedPostType(post.postType || null);
            setSelectedCity(post.street ? post.street.city : null);
            setSelectedStreet(post.street || null);
            setSelectedDriver(post.driver || null);
            setSelectedPostStatus(post.postStatus || null);
            setSelectedType(post ? t(post.type) : null);
            setSelectedChangeStatus(post ? t(post.changeStatus) : null);
            setUpdateErrors({});

        }
    }, [post]);

    useEffect(() => {
        fetchPost();
        fetchCityPrices();
    }, []);

    useEffect(() => {
        setShowAllDrivers(false);
        updateTransportationPrice(selectedCity ? selectedCity.id : null);
    }, [selectedCity]);

    useEffect(() => {
        updateTransportationPrice(selectedStreet ? selectedStreet.city.id : null);
    }, [selectedStreet]);


    useEffect(() => {
        updateDriverPrice();
    }, [selectedDriver, selectedStreet]);


    useEffect(() => {
        if (pdfPostId) {
            pdfPost(pdfPostId);
            setPdfPostId(null);
        }
    }, [pdfPostId]);

    return (
        <Box sx={{
            p: isTablet ? 0.6 : 2,
            backgroundColor: theme.palette.secondary.main,
        }}>

            {showPopup && (
                <Popup
                    text={popupMsg}
                    type={popupType}
                    onClose={() => setShowPopup(false)}
                />
            )}
            {
                isModalLoading ? <Box sx={{ justifyContent: 'center', display: 'flex', my: 10 }} >
                    <CircularProgress color="primary" size={28} />
                </Box>
                    :
                    <Box
                        component="form"
                        onSubmit={handleSubmit}
                        sx={{
                            width: '100%',
                            bgcolor: 'background.paper',
                            borderRadius: 2,
                            border: 1,
                            borderColor: theme.palette.customGrey.borderInput,
                            px: isTablet ? 1 : 4,
                            py: 1
                        }}
                    >

                        <Box sx={{
                            display: isTablet ? 'unset' : 'flex',
                            justifyContent: 'space-between'
                        }}>
                            <Typography id="transition-modal-title" variant="h6" component="h2">
                                {t('updatePost')}
                            </Typography>
                        </Box>

                        {/* row 1 */}
                        <Box sx={{
                            display: isTablet ? 'unset' : 'flex',
                            justifyContent: 'space-between'
                        }}>
                            <Box width={isTablet ? '100%' : '32%'}>
                                <PageDropdown
                                    helperText={updateErrors.page}
                                    error={!!updateErrors.page}
                                    setFormValues={setFormValues}
                                    isFilter={false}
                                    selectedPage={selectedPage}
                                    setSelectedPage={setSelectedPage}
                                />
                            </Box>

                            <Box width={isTablet ? '100%' : '32%'}>
                                <CustomInput
                                    label={t('receiverName')}
                                    placeholder={t('receiverNameHere')}
                                    name="receiverName"
                                    type='text'
                                    value={formValues.receiverName}
                                    error={!!updateErrors.receiverName}
                                    helperText={updateErrors.receiverName}
                                    onChange={handleChange}
                                />
                            </Box>

                            <Box width={isTablet ? '100%' : '32%'}>
                                <CustomInput
                                    label={t('receiverAddress')}
                                    placeholder={t('receiverAddressHere')}
                                    name="receiverAddress"
                                    type='text'
                                    value={formValues.receiverAddress}
                                    error={!!updateErrors.receiverAddress}
                                    helperText={updateErrors.receiverAddress}
                                    onChange={handleChange}
                                />
                            </Box>

                        </Box>

                        {/* row 2 */}
                        <Box sx={{
                            display: isTablet ? 'unset' : 'flex',
                            justifyContent: 'space-between'
                        }}>
                            <Box width={isTablet ? '100%' : '32%'}>
                                <CustomInput
                                    label={t('receiverPhone')}
                                    placeholder={t('receiverPhoneHere')}
                                    name="receiverPhone"
                                    type='text'
                                    value={formValues.receiverPhone}
                                    error={!!updateErrors.receiverPhone}
                                    helperText={updateErrors.receiverPhone}
                                    onChange={handleChange}
                                />
                            </Box>

                            <Box width={isTablet ? '100%' : '32%'}>
                                <CustomInput
                                    label={t('receiverPhoneTwo')}
                                    placeholder={t('receiverPhoneTwoHere')}
                                    name="receiverPhoneTwo"
                                    type='text'
                                    value={formValues.receiverPhoneTwo}
                                    onChange={handleChange}
                                />
                            </Box>

                            <Box width={isTablet ? '100%' : '32%'}>
                                <CustomInput
                                    label={t('invoiceNumber')}
                                    placeholder={t('invoiceNumberHere')}
                                    name="invoiceNumber"
                                    type='text'
                                    value={formValues.invoiceNumber}
                                    error={!!updateErrors.invoiceNumber}
                                    helperText={updateErrors.invoiceNumber}
                                    onChange={handleChange}
                                />
                            </Box>
                        </Box>

                        {/* row 3 */}
                        <Box sx={{
                            display: isTablet ? 'unset' : 'flex',
                            justifyContent: 'space-between'
                        }}>
                            <Box width={isTablet ? '100%' : '32%'}>
                                <CityDropdown
                                    helperText={updateErrors.city}
                                    error={!!updateErrors.city}
                                    setFormValues={setFormValues}
                                    isFilter={false}
                                    selectedCity={selectedCity}
                                    setSelectedCity={setSelectedCity}
                                />
                            </Box>

                            <Box width={isTablet ? '100%' : '32%'}>
                                <StreetDropdown
                                    helperText={updateErrors.street}
                                    error={!!updateErrors.street}
                                    setFormValues={setFormValues}
                                    isFilter={false}
                                    selectedStreet={selectedStreet}
                                    setSelectedStreet={setSelectedStreet}
                                    cityId={selectedCity && selectedCity.id}
                                />
                            </Box>

                            <Box width={isTablet ? '100%' : '32%'} sx={{
                                display: 'flex',
                                alignItems: 'flex-end',
                                justifyContent: 'space-between'
                            }}>
                                <Box width={'85%'}>
                                    <DriverDropdown
                                        helperText={updateErrors.driver}
                                        error={!!updateErrors.driver}
                                        setFormValues={setFormValues}
                                        isFilter={false}
                                        selectedDriver={selectedDriver}
                                        setSelectedDriver={setSelectedDriver}
                                        cityId={(selectedCity && !showAllDrivers) && selectedCity.id}
                                        withPrices={true}
                                    />
                                </Box>
                                <Box>
                                    <p
                                        style={{
                                            color: theme.palette.text.primary,
                                            fontSize: 12,
                                        }}
                                    >
                                        {t("showAllDrivers")}
                                    </p>
                                    <Switch
                                        checked={showAllDrivers}
                                        onClick={() => setShowAllDrivers((prev) => !prev)}
                                    />
                                </Box>
                            </Box>
                        </Box>

                        {/* row 4 */}
                        <Box sx={{
                            display: isTablet ? 'unset' : 'flex',
                            justifyContent: 'space-between'
                        }}>
                            <Box width={isTablet ? '100%' : '32%'}>
                                <CustomInput
                                    label={t('totalPrice')}
                                    placeholder={t('totalPriceHere')}
                                    name="totalPrice"
                                    type='text'
                                    value={formValues.totalPrice ? Number(formValues.totalPrice).toLocaleString() : 0}
                                    error={!!updateErrors.totalPrice}
                                    helperText={updateErrors.totalPrice}
                                    onChange={handleNumberChange}
                                />
                            </Box>

                            <Box width={isTablet ? '100%' : '32%'}>
                                <CustomInput
                                    label={t('transportationPrice')}
                                    placeholder={t('transportationPriceHere')}
                                    name="transportationPrice"
                                    type='text'
                                    value={formValues.transportationPrice ? Number(formValues.transportationPrice).toLocaleString() : 0}
                                    error={!!updateErrors.transportationPrice}
                                    helperText={updateErrors.transportationPrice}
                                    onChange={handleNumberChange}
                                />
                            </Box>

                            <Box width={isTablet ? '100%' : '32%'}>
                                <CustomInput
                                    label={t('driverPrice')}
                                    placeholder={t('driverPriceHere')}
                                    name="driverPrice"
                                    type='text'
                                    value={formValues.driverPrice ? Number(formValues.driverPrice).toLocaleString() : 0}
                                    error={!!updateErrors.driverPrice}
                                    helperText={updateErrors.driverPrice}
                                    onChange={handleNumberChange}
                                />
                            </Box>
                        </Box>

                        {/* row 5 */}
                        <Box sx={{
                            display: isTablet ? 'unset' : 'flex',
                            justifyContent: 'space-between'
                        }}>

                            <Box width={isTablet ? '100%' : '32%'}>
                                <PostTypeDropdown
                                    helperText={updateErrors.postType}
                                    error={!!updateErrors.postType}
                                    setFormValues={setFormValues}
                                    isFilter={false}
                                    selectedPostType={selectedPostType}
                                    setSelectedPostType={setSelectedPostType}
                                />
                            </Box>

                            <Box width={isTablet ? '100%' : '32%'}>
                                <PostStatusDropdown
                                    helperText={updateErrors.postStatus}
                                    error={!!updateErrors.postStatus}
                                    setFormValues={setFormValues}
                                    isFilter={false}
                                    selectedPostStatus={selectedPostStatus}
                                    setSelectedPostStatus={setSelectedPostStatus}
                                    byPassInitial={true}
                                />
                            </Box>

                            <Box width={isTablet ? '100%' : '32%'}>
                                <TypeDropdown
                                    helperText={updateErrors.type}
                                    error={!!updateErrors.type}
                                    setFormValues={setFormValues}
                                    isFilter={false}
                                    selectedType={selectedType}
                                    setSelectedType={setSelectedType}
                                />
                            </Box>

                        </Box>

                        {/* row 6 */}
                        <Box sx={{
                            display: isTablet ? 'unset' : 'flex',
                            justifyContent: 'space-between'
                        }}>

                            <Box width={isTablet ? '100%' : '66%'}>
                                <CustomInput
                                    label={t('note')}
                                    placeholder={t('noteHere')}
                                    name="note"
                                    type='text'
                                    value={formValues.note}
                                    onChange={handleChange}
                                />
                            </Box>

                            {selectedType === t('change') && <Box width={isTablet ? '100%' : '32%'}>
                                <ChangeStatusDropdown
                                    helperText={updateErrors.changeStatus}
                                    error={!!updateErrors.changeStatus}
                                    setFormValues={setFormValues}
                                    isFilter={false}
                                    selectedChangeStatus={selectedChangeStatus}
                                    setSelectedChangeStatus={setSelectedChangeStatus}
                                />
                            </Box>}

                        </Box>

                        {blockedNumber && (
                            <Typography align="center" color='warning' variant="body2" sx={{ mt: 2 }}>
                                {t('blockedNumberExistsWarning')}
                            </Typography>
                        )}

                        {updateErrors.general && (
                            <Typography align="center" color="error" variant="body2" sx={{ mt: 2 }}>
                                {updateErrors.general}
                            </Typography>
                        )}

                        <Box sx={{
                            display: 'flex',
                            flexDirection: isTablet ? 'column' : 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            mt: updateErrors.general ? (isTablet ? 1 : 2) : (isTablet ? 2 : 4)
                        }}>
                            <Button
                                type="submit"
                                disabled={isLoading}
                                variant="contained"
                                color="primary"
                                sx={{ textTransform: 'none', width: 140, height: 40 }}
                            >
                                {isLoading ? <CircularProgress color="secondary" size={28} /> :
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <p>{t('update')}</p>
                                        <DriveFileRenameOutlineOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                                    </Box>
                                }
                            </Button>

                            <Box sx={{
                                width: isTablet ? 0 : 20,
                                height: isTablet ? 10 : 0
                            }}> </Box>
                            <Button
                                type="submit"
                                disabled={isLoading}
                                variant="contained"
                                color="primary"
                                sx={{ textTransform: 'none', width: 140, height: 40 }}
                                onClick={() => setPdf(true)}
                            >
                                {isLoading || isPDF ? <CircularProgress color="secondary" size={28} /> :
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <p>{t('pdf')}</p>
                                        <Box width={'6px'}> </Box>
                                        <PictureAsPdfOutlinedIcon fontSize="small" />
                                    </Box>
                                }
                            </Button>
                            <Box sx={{
                                width: isTablet ? 0 : 20,
                                height: isTablet ? 10 : 0
                            }}> </Box>

                            <Button
                                type="submit"
                                variant="contained"
                                disabled={isLoading}
                                color="primary"
                                sx={{ textTransform: 'none', width: 140, height: 40 }}
                                onClick={() => setPrint(true)}
                            >
                                {isLoading ? <CircularProgress color="secondary" size={28} /> :
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        <p>{t('print')}</p>
                                        <Box width={'6px'}> </Box>
                                        <LocalPrintshopOutlinedIcon fontSize="small" />
                                    </Box>
                                }
                            </Button>
                        </Box>
                    </Box>
            }
        </Box>
    );
}

export default UpdatePost;